module.exports = __webpack_public_path__ + "static/media/ox.b5d6d086.svg";